module.exports = __webpack_public_path__ + "img/zwingBlack.6de3599a.svg";